import i18n from 'services/i18n'
import singleCertificateHelper from '../helpers/singleCertificateHelper'
import listCertificateHelper from '../helpers/listCertificateHelper'
import { formattedDateForCountry } from 'components/shared/mixins/dateHelper'

const unitForHour = 'h'
// Note: `course` should be named `certificate` but for now it would be too much modified lines. After auth credits change, it should be renamed.
//       `certificate` should be renamed to `certificateDocument` to not mix up
function createSingleCertificate (course, userName) {
    let certificate = singleCertificateHelper.getNewPdfObject()
    certificate = singleCertificateHelper.setupNewPdfPage(certificate)
    singleCertificateHelper.resetStartCoordinate()

    singleCertificateHelper.setCertificateLabel(certificate, course)
    singleCertificateHelper.setCompletedOnDate(certificate, course)
    singleCertificateHelper.setCourseTitle(certificate, course)
    singleCertificateHelper.setCourseDescription(certificate, course)
    singleCertificateHelper.setUserNameHasCompletedCourse(certificate, course, userName)
    singleCertificateHelper.setCourseInstructor(certificate, course)
    singleCertificateHelper.setCourseType(certificate, course, singleCertificateHelper.isLearningPath(course))
    singleCertificateHelper.setCoursePublishDate(certificate, course, singleCertificateHelper.isLearningPath(course))
    singleCertificateHelper.setCourseDuration(certificate, course, 'h')
    singleCertificateHelper.setAuthorizations(certificate, course, singleCertificateHelper.isLearningPath(course))
    singleCertificateHelper.setContactInfo(certificate)
    if (singleCertificateHelper.isDigitalClassRoom(course)) {
        singleCertificateHelper.setDigitalClassRoomTrainingDate(certificate, course)
    }

    if (singleCertificateHelper.isLearningPath(course)) {
        singleCertificateHelper.addInfoTextForListOfCourses(certificate)

        let pageNumber = 1
        let courseListNumber = 1
        let rowCoordinate = 66
        let totalDuration = 0

        singleCertificateHelper.addPageNumber(certificate, pageNumber)
        pageNumber++
        certificate.addPage()
        listCertificateHelper.setupNewPdfPage(certificate)
        listCertificateHelper.addPageNumber(certificate, pageNumber)
        listCertificateHelper.addLearningPathCourseListParagraph(certificate, course.learningPathName)
        listCertificateHelper.setCertificateListLabel(certificate, true)
        certificate = listCertificateHelper.setColumnLabels(certificate)
        singleCertificateHelper.setContactInfo(certificate)

        course.courseCertificates.forEach((courseCertificate) => {
            if (rowCoordinate > 224) {
                rowCoordinate = 66
                pageNumber += 1
                certificate.addPage()
                listCertificateHelper.setupNewPdfPage(certificate)
                listCertificateHelper.addPageNumber(certificate, pageNumber)
                listCertificateHelper.setColumnLabels(certificate)
            }
            certificate.setFontSize(10)
            certificate.setFont('Nunito-Regular')
            certificate.setTextColor('black')
            certificate.text(13, rowCoordinate, courseListNumber.toString() + '.')
            let splitTitle = certificate.splitTextToSize(courseCertificate.courseTitle.replace(/"/g, ''), 105)
            certificate.text(18, rowCoordinate, splitTitle)

            listCertificateHelper.setAuthorizationsForIndividualCourse(certificate, courseCertificate, rowCoordinate)

            certificate.text(180, rowCoordinate, formattedDateForCountry(courseCertificate.date))
            certificate.setFontSize(8)

            // Check Splitted title array length and add more space if needed. If title goes over 105 characters, splitted pieces are in the array cells
            if (splitTitle.length > 1) {
                rowCoordinate += (4 * (splitTitle.length - 1))
            }
            if (courseCertificate.instructors?.length > 0 && courseCertificate.duration !== null && courseCertificate.courseTypeValue) {
                certificate.text(18, (rowCoordinate + 4), singleCertificateHelper.getInstructors(courseCertificate).replace(/"/g, '') +
                    ' | ' + singleCertificateHelper.getCourseType(courseCertificate.courseTypeValue) + ' | ' +
                    listCertificateHelper.convertMinutesToHours(courseCertificate.duration, unitForHour))
            }
            courseListNumber += 1
            rowCoordinate += 12

            if (courseCertificate.durations.length > 2) {
                rowCoordinate += (courseCertificate.durations.length - 2) * 4
            }

            if (courseCertificate.duration) {
                totalDuration += parseInt(courseCertificate.duration)
            }
        })

        certificate = listCertificateHelper.setTotalWatchedAmountLabel(certificate, totalDuration, 'h', singleCertificateHelper.isLearningPath(course))
    }

    certificate.setProperties({
        title: i18n.t('Certificates.training_certificate')
    })
    window.open(certificate.output('bloburl'))
}

function createListCertificate (filteredCourseList, userName) {
    let certificate = singleCertificateHelper.getNewPdfObject()
    listCertificateHelper.setupNewPdfPage(certificate)
    let rowCoordinate = 72
    let pageNumber = 1
    let courseListNumber = 0
    let totalDuration = 0

    certificate = listCertificateHelper.setCertificateListLabel(certificate)
    certificate = listCertificateHelper.setUserNameHasCompletedCourses(certificate, userName)
    certificate = listCertificateHelper.setColumnLabels(certificate)
    let courseIds = []

    if (filteredCourseList.learningPaths.length > 0) {
        listCertificateHelper.addCourseTypeSubHeader('', certificate, (rowCoordinate - 7), i18n.t('CertificateList.course_type_learning_paths'))
    }

    filteredCourseList.learningPaths.forEach((learningPath) => {
        courseListNumber = 1
        if (rowCoordinate > 219) {
            listCertificateHelper.addPageNumber(certificate, pageNumber)
            rowCoordinate = 72
            pageNumber += 1
            certificate.addPage()
            listCertificateHelper.setupNewPdfPage(certificate)
            listCertificateHelper.addPageNumber(certificate, pageNumber)
            listCertificateHelper.setColumnLabels(certificate)
        }
        certificate.setFont('icomoon')
        certificate.setFontSize(10)
        certificate.text(13, rowCoordinate, '')
        certificate.setFont('Nunito-Bold')
        certificate.setFontSize(10)
        let splitTitle = certificate.splitTextToSize(learningPath.title.replace(/"/g, ''), 110)
        certificate.text(19, rowCoordinate, splitTitle)
        certificate.setFontSize(10)
        certificate.text(180, rowCoordinate, formattedDateForCountry(learningPath.certificate.date))
        rowCoordinate += 6

        if (splitTitle.length > 1) {
            rowCoordinate += (4 * (splitTitle.length - 1))
        }

        learningPath.certificate.courseCertificates.forEach((courseCertificate) => {
            certificate.setFont('Nunito-Regular')
            certificate.setFontSize(10)
            certificate.text(22, rowCoordinate, courseListNumber.toString() + '.')
            let splitTitle = certificate.splitTextToSize(courseCertificate.courseTitle.replace(/"/g, ''), 105)
            certificate.text(28, rowCoordinate, splitTitle)
            if (courseCertificate.durations !== undefined && courseCertificate.durations !== null && courseCertificate.durations.length > 0) {
                let certsList = ''
                let authorizationCoordinate = rowCoordinate
                certificate.setFontSize(9)
                courseCertificate.durations.forEach((authorization) => {
                    const cert = authorization.category + ': ' + (authorization.credits).toFixed(2)
                    certificate.text(140, authorizationCoordinate, cert)
                    authorizationCoordinate += 4
                })
                certificate.setFontSize(10)
                certsList = certsList.slice(0, certsList.length - 2)
                certificate.text(150, rowCoordinate, certsList)
            }
            certificate.text(180, rowCoordinate, formattedDateForCountry(courseCertificate.date))
            certificate.setFontSize(8)
            // Check Splitted title array length and add more space if needed. If title goes over 105 characters, splitted pieces are in the array cells
            if (splitTitle.length > 1) {
                rowCoordinate += (4 * (splitTitle.length - 1))
            }
            if (courseCertificate.instructors?.length > 0 && courseCertificate.duration !== null && courseCertificate.courseType?.value !== undefined) {
                certificate.text(28, (rowCoordinate + 4), singleCertificateHelper.getInstructors(courseCertificate).replace(/"/g, '') +
                    ' | ' + singleCertificateHelper.getCourseType(courseCertificate.course.type.value) + ' | ' +
                    listCertificateHelper.convertMinutesToHours(courseCertificate.duration, unitForHour))
            }
            courseListNumber += 1
            rowCoordinate += 10
            if (courseCertificate.durations.length > 2) {
                rowCoordinate += (courseCertificate.durations.length - 2) * 4
            }
            if (!courseIds.includes(courseCertificate.courseId) && courseCertificate.duration) {
                totalDuration += parseInt(courseCertificate.duration)
            }
            courseIds.push(courseCertificate.courseId)
            if (rowCoordinate > 219) {
                listCertificateHelper.addPageNumber(certificate, pageNumber)
                rowCoordinate = 72
                pageNumber += 1
                certificate.addPage()
                listCertificateHelper.setupNewPdfPage(certificate)
                listCertificateHelper.addPageNumber(certificate, pageNumber)
                listCertificateHelper.setColumnLabels(certificate)
            }
        })
    })

    //  Always add new page after finishing of the learning paths, makes documents a bit more cleaner
    //  Don't add new page if there weren't any LP certs
    if (filteredCourseList.learningPaths.length > 0) {
        listCertificateHelper.addPageNumber(certificate, pageNumber)
        rowCoordinate = 72
        pageNumber += 1
        certificate.addPage()
        listCertificateHelper.setupNewPdfPage(certificate)
        listCertificateHelper.addPageNumber(certificate, pageNumber)
    }
    courseListNumber = 1
    const listableCourses = filteredCourseList.courses.filter(course => !courseIds.includes(course.id))

    if (listableCourses.length > 0) {
        listCertificateHelper.addCourseTypeSubHeader('', certificate, (rowCoordinate - 7), i18n.t('CertificateList.course_type_courses'))
    }

    listableCourses.forEach((course) => {
        let courseCertificate = course.certificate
        if (rowCoordinate > 219) {
            rowCoordinate = 72
            listCertificateHelper.addPageNumber(certificate, pageNumber)
            pageNumber += 1
            certificate.addPage()
            listCertificateHelper.setupNewPdfPage(certificate)
            listCertificateHelper.addPageNumber(certificate, pageNumber)
            listCertificateHelper.setColumnLabels(certificate)
        }
        certificate.setFontSize(10)
        certificate.setFont('Nunito-Regular')
        certificate.text(11, rowCoordinate, courseListNumber.toString() + '.')

        let splitTitle = certificate.splitTextToSize(courseCertificate.courseTitle.replace(/"/g, ''), 110)
        certificate.text(19, rowCoordinate, splitTitle)
        if (courseCertificate.durations !== undefined && courseCertificate.durations !== null && courseCertificate.durations.length > 0) {
            let authorizationCoordinate = rowCoordinate
            certificate.setFontSize(9)
            courseCertificate.durations.forEach((authorization) => {
                const cert = authorization.category + ': ' + (authorization.credits).toFixed(2)
                certificate.text(140, authorizationCoordinate, cert)
                authorizationCoordinate += 4
            })
        }
        certificate.setFontSize(10)
        certificate.text(180, rowCoordinate, formattedDateForCountry(course.certificate.certificationDate))
        certificate.setFontSize(8)
        certificate.setFont('Nunito-Regular')
        // Apply the space for titles longer than 1 row
        rowCoordinate += (4 * (splitTitle.length - 1))

        if (courseCertificate.instructors?.length > 0 && courseCertificate.duration !== null && courseCertificate.courseTypeValue) {
            certificate.text(19, (rowCoordinate + 4), singleCertificateHelper.getInstructors(courseCertificate).replace(/"/g, '') +
                ' | ' + singleCertificateHelper.getCourseType(courseCertificate.courseTypeValue) + ' | ' +
                listCertificateHelper.convertMinutesToHours(courseCertificate.duration, unitForHour))
        }
        courseListNumber += 1
        rowCoordinate += 10
        if (courseCertificate.duration) {
            totalDuration += parseInt(courseCertificate.duration)
        }
        // Add more space for multiple authorizations, without any long titles we have rows for 2 authorizations, otherwise calculate space for each authorization
        if (courseCertificate.durations.length > 2) {
            rowCoordinate += (courseCertificate.durations.length - 2) * 4
        }
    })

    certificate = listCertificateHelper.setTotalWatchedAmountLabel(certificate, totalDuration, 'h')

    const authorizationsSummary = listCertificateHelper.getSummaryForAllAuthorizationDurations(listableCourses, filteredCourseList.learningPaths)

    certificate.setFontSize(11)
    let summaryCoordinate = 250
    for (let authorization in authorizationsSummary) {
        certificate.setTextColor('black')
        const text = i18n.t('CertificateList.authorization_summary', { authorizationName: authorization })
        certificate.text(11, summaryCoordinate, text)
        certificate.setTextColor('#e47700')
        certificate.text(listCertificateHelper.getLineCoordinateForAttribute(certificate, text), summaryCoordinate, authorizationsSummary[authorization].toFixed(2))
        summaryCoordinate += 5
    }
    certificate.setFontSize(13)
    certificate.setTextColor('black')
    certificate = singleCertificateHelper.setContactInfo(certificate)

    certificate.setProperties({
        title: i18n.t('Certificates.training_certificate_list')
    })
    window.open(certificate.output('bloburl'))
}

function truncate (text, length) {
    if (text.length < length) {
        return text
    } else {
        return text.substring(0, length) + '...'
    }
}

export default {
    createSingleCertificate,
    createListCertificate,
    truncate
}
